import * as i0 from '@angular/core';
import { Directive, Input, Pipe, Component, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Subject, BehaviorSubject, of, takeUntil } from 'rxjs';
import { switchMap, startWith, catchError, shareReplay, map } from 'rxjs/operators';
import * as i1 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import * as moment from 'moment';
import * as i3 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i4 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i8 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i9 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i10 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i11 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i12 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { CdkTableModule } from '@angular/cdk/table';

// See also: https://blog.angular-university.io/angular-material-data-table/
class PaginatedDataSource {
    constructor(endpoint, initialSort, size = 10) {
        this.pageNumber = new Subject();
        this.multiPurposeFindQueryParamsCb = null;
        this.pageSize = 10;
        this.pageSize = size;
        this.sort = new BehaviorSubject(initialSort);
        this.page$ = this.sort.pipe(switchMap(sort => this.pageNumber.pipe(startWith(0), switchMap((page) => {
            let sortParam = null;
            if (sort.active) {
                sortParam = {};
                sortParam[sort.active.toString()] = sort.direction == 'desc' ? 1 : -1;
            }
            let multiPurposeFindQueryParams = {};
            if (this.multiPurposeFindQueryParamsCb) {
                multiPurposeFindQueryParams = this.multiPurposeFindQueryParamsCb();
            }
            const result = endpoint({ ...multiPurposeFindQueryParams, pageSize: this.pageSize, pageOffset: page, sort: sortParam });
            return result;
        }), catchError((err) => {
            return of({
                info: {
                    recordTotal: 0,
                    recordSkip: 0,
                    pageOffset: 0,
                    pageSize: 1
                }, results: []
            });
        }))), shareReplay(1));
    }
    reload() {
        this.sort.next(this.sort.getValue());
    }
    sortBy(sort) {
        const lastSort = this.sort.getValue();
        const nextSort = { ...lastSort, ...sort };
        this.sort.next(nextSort);
    }
    fetch(page, pagesize) {
        this.pageSize = pagesize;
        this.pageNumber.next(page);
    }
    connect() {
        return this.page$.pipe(map(page => page?.results ? page?.results : []));
    }
    disconnect() {
    }
}

class ViewSettingsLocal {
    constructor(breakpointObserver, destroy$) {
        this.breakpointObserver = breakpointObserver;
        this.destroy$ = destroy$;
    }
    _setConfigItem(path, val) {
        let storage = localStorage.getItem('uiconfig.v6');
        let obj = null;
        try {
            obj = JSON.parse(storage);
        }
        catch (err) {
            obj = {};
        }
        if (!obj) {
            obj = {};
        }
        this.stringToObj(path, val, obj);
        localStorage.setItem('.' + 'uiconfig.v6', JSON.stringify(obj));
    }
    _getConfigItem(path) {
        let storage = localStorage.getItem('.' + 'uiconfig.v6');
        let obj;
        try {
            obj = JSON.parse(storage);
        }
        catch (err) {
            return null;
        }
        if (!obj) {
            return null;
        }
        let parts = path.split('.'), part;
        let last = parts.pop();
        while (part = parts.shift()) {
            if (typeof obj[part] != "object") {
                return null;
            }
            obj = obj[part]; // update "pointer"
        }
        return obj[last];
    }
    stringToObj(path, value, obj) {
        let parts = path.split("."), part;
        let last = parts.pop();
        while (part = parts.shift()) {
            if (typeof obj[part] != "object")
                obj[part] = {};
            obj = obj[part]; // update "pointer"
        }
        obj[last] = value;
    }
    get isHandset() {
        return this.formfactor == "HandsetPortrait";
    }
}

class FilterBase {
}
class MongoFilter {
    constructor() {
        this.implicitFilter = null;
        this.dataFilters = new Map();
    }
    setImplicitFilter(statement) {
        this.implicitFilter = statement;
    }
    getFilterQueryParam(_filter = {}) {
        let allAndFilters = [_filter];
        this.dataFilters.forEach((dataFilterOrs) => {
            allAndFilters.push({ "$or": dataFilterOrs });
        });
        if (this.implicitFilter) {
            allAndFilters.push(this.implicitFilter);
        }
        return { "$and": allAndFilters };
    }
    add(col, obj) {
        let ors = this.dataFilters.get(col);
        if (!ors) {
            ors = [];
        }
        ors.push(obj);
        this.dataFilters.set(col, ors);
    }
    change(propertyNamesString, val, type) {
        this.dataFilters.delete(propertyNamesString);
        if (!val || val.trim().length == 0) {
            return;
        }
        let propertyNames = propertyNamesString.split(',');
        for (let propertyName of propertyNames) {
            let obj = {};
            if (type != 'date' && type != 'datestring') {
                let valMongo;
                let match;
                // GTE
                match = val.match("(>\=)(.*)");
                if (match) {
                    valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    obj[propertyName] = { "$gte": valMongo };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // GT
                match = val.match("(>)(.*)");
                if (match) {
                    valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    obj[propertyName] = { "$gt": valMongo };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LTE
                match = val.match("(<\=)(.*)");
                if (match) {
                    valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    obj[propertyName] = { "$lte": valMongo };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LT
                match = val.match("(<)(.*)");
                if (match) {
                    valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    obj[propertyName] = { "$lt": valMongo };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // NE
                match = val.match("(\!\=)(.*)");
                if (match) {
                    valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    obj[propertyName] = { "$ne": valMongo };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // Exact
                match = val.match("(\=)(.*)");
                if (match) {
                    if (match[2] && match[2].trim() == "null") {
                        valMongo = null;
                    }
                    else {
                        valMongo = type == "number" ? Number(match[2]) : match[2].trim();
                    }
                    obj[propertyName] = valMongo;
                    this.add(propertyNamesString, obj);
                    continue;
                }
                if (type == "number") {
                    if (val == "null") {
                        valMongo = null;
                    }
                    else {
                        valMongo = Number(val);
                    }
                    obj[propertyName] = valMongo;
                }
                else if (type == "boolean") {
                    if (['0', 'f', 'n'].includes(val.toLocaleLowerCase())) {
                        valMongo = false;
                    }
                    else {
                        valMongo = true;
                    }
                    obj[propertyName] = valMongo;
                }
                else {
                    valMongo = val.trim();
                    if (propertyName.indexOf('Id') == 0) {
                        obj[propertyName] = valMongo;
                    }
                    else {
                        obj[propertyName] = { "$regex": valMongo };
                    }
                }
                this.add(propertyNamesString, obj);
            }
            else if (type == 'date') {
                // GTE
                let match = val.match("(>=)(.*)");
                if (match) {
                    obj[propertyName] = { "$gte": "Date(" + moment(match[2].trim()).toISOString() + ")" };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // GT
                match = val.match("(>)(.*)");
                if (match) {
                    obj[propertyName] = { "$gt": "Date(" + moment(match[2].trim()).toISOString() + ")" };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LTE
                match = val.match("(<=)(.*)");
                if (match) {
                    obj[propertyName] = { "$lte": "Date(" + moment(match[2].trim()).toISOString() + ")" };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LT
                match = val.match("(<)(.*)");
                if (match) {
                    obj[propertyName] = { "$lt": "Date(" + moment(match[2].trim()).toISOString() + ")" };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // NE
                match = val.match("(!=)(.*)");
                if (match) {
                    obj[propertyName] = { "$ne": "Date(" + moment(match[2].trim()).toISOString() + ")" };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                ;
                let startDay = moment(val).toISOString();
                let endDay = moment(val).toISOString();
                obj[propertyName] = { "$gte": "Date(" + startDay + ")", "$lte": "Date(" + endDay + ")" };
                this.add(propertyNamesString, obj);
            }
            else if (type == 'datestring') {
                // GTE
                let match = val.match("(>=)(.*)");
                if (match) {
                    obj[propertyName] = { "$gte": moment(match[2].trim()).toISOString() };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // GT
                match = val.match("(>)(.*)");
                if (match) {
                    obj[propertyName] = { "$gt": moment(match[2].trim()).toISOString() };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LTE
                match = val.match("(<=)(.*)");
                if (match) {
                    obj[propertyName] = { "$lte": moment(match[2].trim()).toISOString() };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // LT
                match = val.match("(<)(.*)");
                if (match) {
                    obj[propertyName] = { "$lt": moment(match[2].trim()).toISOString() };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                // NE
                match = val.match("(!=)(.*)");
                if (match) {
                    obj[propertyName] = { "$ne": moment(match[2].trim()).toISOString() };
                    this.add(propertyNamesString, obj);
                    continue;
                }
                ;
                let startDay = moment(val).toISOString();
                let endDay = moment(val).toISOString();
                obj[propertyName] = { "$gte": startDay, "$lte": endDay };
                this.add(propertyNamesString, obj);
            }
        }
    }
}

/**
 * Add the template content to the DOM unless the condition is true.
 */
class ColumnValueDirective {
    set columnValue(context) {
        this.context.$implicit = this.context.ngVar = context;
        if (!this.hasView) {
            this.vcRef.createEmbeddedView(this.templateRef, this.context);
            this.hasView = true;
        }
    }
    constructor(templateRef, vcRef) {
        this.templateRef = templateRef;
        this.vcRef = vcRef;
        this.context = {
            $implicit: null,
            ngVar: null,
        };
        this.hasView = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: ColumnValueDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.11", type: ColumnValueDirective, selector: "[columnValue]", inputs: { columnValue: "columnValue" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: ColumnValueDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[columnValue]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { columnValue: [{
                type: Input
            }] } });

const objectToQueryString = (params) => {
    return Object.keys(params).map((key) => {
        let val = params[key];
        if (typeof params[key] == 'object') {
            val = JSON.stringify(val);
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(val);
    }).join('&');
};
const getTitleFromKey = (key, singular) => {
    let title = key.replace(/([A-Z\._])(?![A-Z\._])/g, " $1");
    title = title.replace(/\./g, ' ');
    title = title.replace(/\_/g, ' ');
    let composedTitle = title.split(' ').map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ');
    if (singular && composedTitle.charAt(composedTitle.length - 1) == 's') {
        composedTitle = composedTitle.substring(0, composedTitle.length - 1);
    }
    return composedTitle;
};
const isIp = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
const isIsoDate = (str) => {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str))
        return false;
    var d = new Date(str);
    return d.toISOString() === str;
};
function versionCompare(v1, v2, options) {
    var lexicographical = options && options.lexicographical, zeroExtend = options && options.zeroExtend, v1parts = v1.split('.'), v2parts = v2.split('.');
    function isValidPart(x) {
        return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
    }
    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
        return NaN;
    }
    if (zeroExtend) {
        while (v1parts.length < v2parts.length)
            v1parts.push("0");
        while (v2parts.length < v1parts.length)
            v2parts.push("0");
    }
    if (!lexicographical) {
        v1parts = v1parts.map(Number);
        v2parts = v2parts.map(Number);
    }
    for (var i = 0; i < v1parts.length; ++i) {
        if (v2parts.length == i) {
            return 1;
        }
        if (v1parts[i] == v2parts[i]) {
            continue;
        }
        else if (v1parts[i] > v2parts[i]) {
            return 1;
        }
        else {
            return -1;
        }
    }
    if (v1parts.length != v2parts.length) {
        return -1;
    }
    return 0;
}

class GetTitleFromKeyPipe {
    transform(colOrKey, singular) {
        let name;
        if (typeof (colOrKey) == "object") {
            if (colOrKey.title) {
                return colOrKey.title;
            }
            name = colOrKey.name;
        }
        else {
            name = colOrKey;
        }
        return name ? getTitleFromKey(name, singular) : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: GetTitleFromKeyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: GetTitleFromKeyPipe, name: "getTitleFromKey" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: GetTitleFromKeyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'getTitleFromKey',
                    pure: true
                }]
        }] });

function getObjectValue(o, pathItems, depth = 0) {
    if (o == null) {
        return '';
    }
    if (depth > 0 && depth >= pathItems.length) {
        if (typeof (o) == 'object') {
            return JSON.stringify(o);
        }
        return o;
    }
    if (Array.isArray(o[pathItems[depth]])) {
        let ret = [];
        for (let item of o[pathItems[depth]]) {
            let val = getObjectValue(item, pathItems, depth + 1);
            if (Array.isArray(val)) {
                ret = ret.concat(val);
            }
            else {
                ret.push(val);
            }
        }
        return ret.filter((v, i, a) => a.indexOf(v) === i);
        //.map(item=>item).join(' ');
    }
    if (typeof o[pathItems[depth]] == 'object') {
        return getObjectValue(o[pathItems[depth]], pathItems, depth + 1);
    }
    return o[pathItems[depth]];
}
class GetObjectPropertyPipe {
    async transform(object, col) {
        let name;
        if (typeof (col) == "object") {
            if (col.valueAsyncGet) {
                let val = await col.valueAsyncGet(object);
                return val ? String(val) : '';
            }
            name = col.name;
        }
        else {
            name = col;
        }
        const pathOptions = name.split(',');
        let val = "";
        for (let pathOption of pathOptions) {
            const pathItems = pathOption.split('.');
            val = getObjectValue(object, pathItems);
            if (val && val != '') {
                return val;
            }
        }
        return val;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: GetObjectPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: GetObjectPropertyPipe, name: "getObjectPropertyValue" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: GetObjectPropertyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'getObjectPropertyValue',
                    pure: true
                }]
        }] });

class ColumnSelectPipe {
    transform(columns, refresh, isfilterCol) {
        if (!columns) {
            return [];
        }
        return columns.filter((col) => {
            return col.show;
        }).map((col) => {
            return isfilterCol ? col.filterName : col.name;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: ColumnSelectPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: ColumnSelectPipe, name: "columnSelect" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: ColumnSelectPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'columnSelect',
                    pure: true
                }]
        }] });

class CrudTableComponent {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.columns = [{ name: "_id" }];
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 25, 100];
        this.features = {};
        this.destroy$ = new Subject();
        this.viewSettings = new ViewSettingsLocal(this.breakpointObserver, this.destroy$);
        this.tableColumnsPresetConfig = [{ title: "Custom", columns: null, unwinds: null }];
        this.selectedTableColumnsPresetConfig = this.tableColumnsPresetConfig[0];
        this.filter = new MongoFilter();
        this.tableUnwindConfig = [];
        this.refresh = 1;
        this.breakpointObserver
            .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetPortrait])
            .pipe(takeUntil(this.destroy$))
            .subscribe((state) => {
            if (state.matches) {
                this.viewSettings.formfactor = "HandsetPortrait";
            }
            else {
                this.viewSettings.formfactor = "Landscape";
            }
            this.updateColumnVisibility();
            this.doRefresh();
        });
    }
    ;
    setColumnInfo() {
        this._columns = this.columns.map((col) => {
            if (typeof (col) == "object") {
                return col;
            }
            else {
                const match = col.match(/\[(.*)\]/);
                if (match) {
                    return { name: match[1], show: true, array: true };
                }
                else {
                    return { name: col, show: true };
                }
            }
        }).map((col) => { return { ...col, filterName: col.name + "_filter" }; });
        this.dataSource.multiPurposeFindQueryParamsCb = () => { return this.getMultiPurposeFindQueryParams(); };
    }
    ngOnChanges() {
        this.setColumnInfo();
    }
    ngOnInit() {
        this.setColumnInfo();
    }
    changeColumns() {
        for (let col of this._columns) {
            this.viewSettings._setConfigItem(this.viewSettings.formfactor + '.' + this.name + '.col.' + col.name, col.show);
        }
        this.doRefresh();
        // this.fetch();
    }
    updateColumnVisibility() {
        if (!this._columns) {
            return;
        }
        if (this.viewSettings.formfactor == "HandsetPortrait") {
            for (let col of this._columns) {
                let item = this.viewSettings._getConfigItem(this.viewSettings.formfactor + '.' + this.name + '.col.' + col.name);
                col.show = item != null ? item == true : !col.hideSmall;
            }
        }
        else {
            for (let col of this._columns) {
                let item = this.viewSettings._getConfigItem(this.viewSettings.formfactor + '.' + this.name + '.col.' + col.name);
                col.show = item != null ? item == true : col.show;
            }
        }
        // this.updateUnwindColumns();
        for (let col of this._columns) {
            if (col.filterValue && !col.show) {
                col.filterValue = '';
                this.filter.change(col.name, '', col.type);
            }
        }
        this.doRefresh();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    selectCustomColumnsPresetConfig() {
        this.selectedTableColumnsPresetConfig = this.tableColumnsPresetConfig[0];
    }
    doRefresh() {
        this.refresh++;
    }
    async fetch() {
        if (this.dataSource) {
            this.dataSource.reload();
        }
    }
    async resetCacheAndRefresh() {
        this.refresh++;
        this.fetch();
    }
    getMultiPurposeFindQueryParams() {
        let multiPurposeFindQueryParams = {};
        let unwinds = this.getUnwinds();
        if (unwinds.length) {
            multiPurposeFindQueryParams['unwind'] = unwinds;
        }
        //  queryParams.sort = null;
        if (this.getMongoProjection()) {
            multiPurposeFindQueryParams['projection'] = this.getMongoProjection();
        }
        multiPurposeFindQueryParams['filter'] = this.filter.getFilterQueryParam();
        return multiPurposeFindQueryParams;
    }
    getUnwinds() {
        let unwinds = this.tableUnwindConfig.filter(item => item.unwind).map((unwinditems) => {
            return unwinditems.field.split(',').map(unwindItemStr => "$" + unwindItemStr);
        });
        if (unwinds.length) {
            return unwinds.join(",");
        }
        return '';
    }
    getMongoProjection() {
        let projection = {};
        for (let col of this._columns) {
            if (col.show) {
                const options = col.references ? col.references : col.name.split(',');
                for (let o of options) {
                    const base = o.split('.')[0];
                    if (!projection.hasOwnProperty(base)) {
                        projection[base] = "$" + base;
                    }
                }
            }
        }
        return projection;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: CrudTableComponent, deps: [{ token: i1.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.11", type: CrudTableComponent, selector: "mscl-crud-table", inputs: { name: "name", dataSource: "dataSource", columns: "columns", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", features: "features" }, viewQueries: [{ propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<style>\r\n    .crud-table {\r\n        visibility: visible;\r\n    }\r\n\r\n    .crud-table .mat-mdc-row ::ng-deep .mat-mdc-cell {\r\n        transition: 0.3s\r\n    }\r\n\r\n    .crud-table .mat-mdc-row:hover ::ng-deep .mat-mdc-cell {\r\n        background: #ddd;\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-header-cell {\r\n        color: rgba(0, 0, 0, 0.54);\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-chip-list-wrapper {\r\n        display: flex;\r\n        flex-direction: row;\r\n        flex-wrap: nowrap !important;\r\n        align-items: center;\r\n        margin: -4px;\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-menu-panel {\r\n        min-width: 112px;\r\n        max-width: 500px !important;\r\n    }\r\n\r\n    .crud-table ::ng-deep.mat-mdc-select-value-text {\r\n        color: #000\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-table .mat-mdc-cell span {\r\n        display: inline-flex\r\n    }\r\n\r\n    .crud-table ::ng-deep button {\r\n        border-width: 0px\r\n    }\r\n\r\n    .crud-table ::ng-deep button:hover {\r\n        transform: scale(1.2);\r\n    }\r\n</style>\r\n\r\n<div class=\"crud-table\" style=\"margin:10px\">\r\n\r\n\r\n    <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8 demo-table\">\r\n        <!-- Position Column -->\r\n\r\n        <ng-container *ngFor=\"let col of _columns\">\r\n            <ng-container [matColumnDef]=\"col.name\">\r\n                <th mat-header-cell *matHeaderCellDef>{{col|getTitleFromKey }}</th>\r\n                <td mat-cell *matCellDef=\"let element\">\r\n\r\n                    <span *columnValue=\"((element   | getObjectPropertyValue:col) |async ); let value\">\r\n \r\n                        <mat-chip-listbox style=\"display:flex;max-height:48px;flex-wrap: nowrap !important;\" *ngIf=\"col.array\">\r\n\r\n                            <span *ngFor=\"let el of value\">\r\n\r\n                                <mat-chip>\r\n                                    {{el}}\r\n                                </mat-chip>\r\n\r\n                            </span>\r\n\r\n                        </mat-chip-listbox>\r\n                        <span style=\"display:flex;max-height:48px;flex-wrap: nowrap !important;\" *ngIf=\"!col.array\">\r\n                            {{value}}\r\n                        </span>\r\n                    </span>\r\n            </ng-container>\r\n\r\n        </ng-container>\r\n\r\n        <ng-container  *ngIf=\"!features.disableFilter\">\r\n        <ng-container *ngFor=\"let col of _columns\" matColumnDef=\"{{col.filterName}}\" >\r\n            <td mat-header-cell *matHeaderCellDef style=\"max-width:100px\">\r\n              <mat-form-field class=\"mat-form-field-column\" style=\"width:100%;\">\r\n    \r\n                <input matInput class=\"form-field\" placeholder=\"Filter\" [ngModelOptions]=\"{standalone: true}\"\r\n                  [(ngModel)]=\"col.filterValue\"\r\n                  (change)=\"this.filter.change(col.name,col.filterValue,col.type);this.fetch();\">\r\n    \r\n              </mat-form-field>\r\n            </td>\r\n          </ng-container>\r\n        </ng-container>\r\n       \r\n        <tr mat-header-row *matHeaderRowDef=\"_columns | columnSelect :refresh\"></tr>\r\n        <ng-container  *ngIf=\"!features.disableFilter\"><tr mat-header-row *matHeaderRowDef=\"_columns | columnSelect :refresh:true\"></tr></ng-container>\r\n        <tr mat-row *matRowDef=\"let row; columns: _columns | columnSelect :refresh;\"></tr>\r\n    </table>\r\n\r\n\r\n    <mat-paginator *ngIf=\"dataSource?.page$ | async as page\" [length]=\"page.info.recordTotal\"\r\n        [pageSize]=\"page.info.pageSize\" [pageIndex]=\"page.info.pageOffset\" [pageSizeOptions]=\"pageSizeOptions\"\r\n        (page)=\"dataSource.fetch($event.pageIndex,$event.pageSize)\">\r\n    </mat-paginator>\r\n\r\n    <mat-toolbar class=\"table-toolbar background-background mat-elevation-z8\">\r\n        <mat-toolbar-row>\r\n            <button matTooltip=\"Select columns\" mat-icon-button [matMenuTriggerFor]=\"columnSelect\"\r\n                *ngIf=\"!features.disableColumnSelection\">\r\n                <mat-icon>view_column</mat-icon>\r\n            </button>\r\n            <mat-menu #columnSelect=\"matMenu\" style=\"width:400px;padding:5px\">\r\n                <mat-checkbox (click)=\"$event.stopPropagation()\" class=\"mat-menu-item\"\r\n                    *ngFor=\"let col of this._columns \" [checked]=\"col.show\"\r\n                    (change)=\"col.show=!col.show;selectCustomColumnsPresetConfig();changeColumns()\">\r\n                    {{col|getTitleFromKey }}</mat-checkbox>\r\n            </mat-menu>\r\n\r\n            <button matTooltip=\"Reset cache and update\" mat-icon-button color=\"primary\"\r\n                (click)=\"resetCacheAndRefresh()\">\r\n                <mat-icon>refresh</mat-icon>\r\n            </button>\r\n\r\n        </mat-toolbar-row>\r\n    </mat-toolbar>\r\n</div>", styles: ["", "\n    .crud-table {\n        visibility: visible;\n    }\n\n    .crud-table .mat-mdc-row ::ng-deep .mat-mdc-cell {\n        transition: 0.3s\n    }\n\n    .crud-table .mat-mdc-row:hover ::ng-deep .mat-mdc-cell {\n        background: #ddd;\n    }\n\n    .crud-table ::ng-deep .mat-mdc-header-cell {\n        color: rgba(0, 0, 0, 0.54);\n    }\n\n    .crud-table ::ng-deep .mat-mdc-chip-list-wrapper {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap !important;\n        align-items: center;\n        margin: -4px;\n    }\n\n    .crud-table ::ng-deep .mat-mdc-menu-panel {\n        min-width: 112px;\n        max-width: 500px !important;\n    }\n\n    .crud-table ::ng-deep.mat-mdc-select-value-text {\n        color: #000\n    }\n\n    .crud-table ::ng-deep .mat-mdc-table .mat-mdc-cell span {\n        display: inline-flex\n    }\n\n    .crud-table ::ng-deep button {\n        border-width: 0px\n    }\n\n    .crud-table ::ng-deep button:hover {\n        transform: scale(1.2);\n    }\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disabled", "disableRipple", "tabIndex", "role", "id", "aria-label", "aria-description", "value", "removable", "highlighted"], outputs: ["removed", "destroyed"], exportAs: ["matChip"] }, { kind: "component", type: i3.MatChipListbox, selector: "mat-chip-listbox", inputs: ["tabIndex", "multiple", "aria-orientation", "selectable", "compareWith", "required", "hideSingleSelectionIndicator", "value"], outputs: ["change"] }, { kind: "component", type: i4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i4.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i4.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: i5.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "component", type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i7.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "directive", type: i7.MatToolbarRow, selector: "mat-toolbar-row", exportAs: ["matToolbarRow"] }, { kind: "component", type: i8.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i8.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i9.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i10.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i11.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i12.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i12.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i12.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ColumnValueDirective, selector: "[columnValue]", inputs: ["columnValue"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: GetTitleFromKeyPipe, name: "getTitleFromKey" }, { kind: "pipe", type: GetObjectPropertyPipe, name: "getObjectPropertyValue" }, { kind: "pipe", type: ColumnSelectPipe, name: "columnSelect" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: CrudTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mscl-crud-table', template: "<style>\r\n    .crud-table {\r\n        visibility: visible;\r\n    }\r\n\r\n    .crud-table .mat-mdc-row ::ng-deep .mat-mdc-cell {\r\n        transition: 0.3s\r\n    }\r\n\r\n    .crud-table .mat-mdc-row:hover ::ng-deep .mat-mdc-cell {\r\n        background: #ddd;\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-header-cell {\r\n        color: rgba(0, 0, 0, 0.54);\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-chip-list-wrapper {\r\n        display: flex;\r\n        flex-direction: row;\r\n        flex-wrap: nowrap !important;\r\n        align-items: center;\r\n        margin: -4px;\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-menu-panel {\r\n        min-width: 112px;\r\n        max-width: 500px !important;\r\n    }\r\n\r\n    .crud-table ::ng-deep.mat-mdc-select-value-text {\r\n        color: #000\r\n    }\r\n\r\n    .crud-table ::ng-deep .mat-mdc-table .mat-mdc-cell span {\r\n        display: inline-flex\r\n    }\r\n\r\n    .crud-table ::ng-deep button {\r\n        border-width: 0px\r\n    }\r\n\r\n    .crud-table ::ng-deep button:hover {\r\n        transform: scale(1.2);\r\n    }\r\n</style>\r\n\r\n<div class=\"crud-table\" style=\"margin:10px\">\r\n\r\n\r\n    <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8 demo-table\">\r\n        <!-- Position Column -->\r\n\r\n        <ng-container *ngFor=\"let col of _columns\">\r\n            <ng-container [matColumnDef]=\"col.name\">\r\n                <th mat-header-cell *matHeaderCellDef>{{col|getTitleFromKey }}</th>\r\n                <td mat-cell *matCellDef=\"let element\">\r\n\r\n                    <span *columnValue=\"((element   | getObjectPropertyValue:col) |async ); let value\">\r\n \r\n                        <mat-chip-listbox style=\"display:flex;max-height:48px;flex-wrap: nowrap !important;\" *ngIf=\"col.array\">\r\n\r\n                            <span *ngFor=\"let el of value\">\r\n\r\n                                <mat-chip>\r\n                                    {{el}}\r\n                                </mat-chip>\r\n\r\n                            </span>\r\n\r\n                        </mat-chip-listbox>\r\n                        <span style=\"display:flex;max-height:48px;flex-wrap: nowrap !important;\" *ngIf=\"!col.array\">\r\n                            {{value}}\r\n                        </span>\r\n                    </span>\r\n            </ng-container>\r\n\r\n        </ng-container>\r\n\r\n        <ng-container  *ngIf=\"!features.disableFilter\">\r\n        <ng-container *ngFor=\"let col of _columns\" matColumnDef=\"{{col.filterName}}\" >\r\n            <td mat-header-cell *matHeaderCellDef style=\"max-width:100px\">\r\n              <mat-form-field class=\"mat-form-field-column\" style=\"width:100%;\">\r\n    \r\n                <input matInput class=\"form-field\" placeholder=\"Filter\" [ngModelOptions]=\"{standalone: true}\"\r\n                  [(ngModel)]=\"col.filterValue\"\r\n                  (change)=\"this.filter.change(col.name,col.filterValue,col.type);this.fetch();\">\r\n    \r\n              </mat-form-field>\r\n            </td>\r\n          </ng-container>\r\n        </ng-container>\r\n       \r\n        <tr mat-header-row *matHeaderRowDef=\"_columns | columnSelect :refresh\"></tr>\r\n        <ng-container  *ngIf=\"!features.disableFilter\"><tr mat-header-row *matHeaderRowDef=\"_columns | columnSelect :refresh:true\"></tr></ng-container>\r\n        <tr mat-row *matRowDef=\"let row; columns: _columns | columnSelect :refresh;\"></tr>\r\n    </table>\r\n\r\n\r\n    <mat-paginator *ngIf=\"dataSource?.page$ | async as page\" [length]=\"page.info.recordTotal\"\r\n        [pageSize]=\"page.info.pageSize\" [pageIndex]=\"page.info.pageOffset\" [pageSizeOptions]=\"pageSizeOptions\"\r\n        (page)=\"dataSource.fetch($event.pageIndex,$event.pageSize)\">\r\n    </mat-paginator>\r\n\r\n    <mat-toolbar class=\"table-toolbar background-background mat-elevation-z8\">\r\n        <mat-toolbar-row>\r\n            <button matTooltip=\"Select columns\" mat-icon-button [matMenuTriggerFor]=\"columnSelect\"\r\n                *ngIf=\"!features.disableColumnSelection\">\r\n                <mat-icon>view_column</mat-icon>\r\n            </button>\r\n            <mat-menu #columnSelect=\"matMenu\" style=\"width:400px;padding:5px\">\r\n                <mat-checkbox (click)=\"$event.stopPropagation()\" class=\"mat-menu-item\"\r\n                    *ngFor=\"let col of this._columns \" [checked]=\"col.show\"\r\n                    (change)=\"col.show=!col.show;selectCustomColumnsPresetConfig();changeColumns()\">\r\n                    {{col|getTitleFromKey }}</mat-checkbox>\r\n            </mat-menu>\r\n\r\n            <button matTooltip=\"Reset cache and update\" mat-icon-button color=\"primary\"\r\n                (click)=\"resetCacheAndRefresh()\">\r\n                <mat-icon>refresh</mat-icon>\r\n            </button>\r\n\r\n        </mat-toolbar-row>\r\n    </mat-toolbar>\r\n</div>", styles: ["\n    .crud-table {\n        visibility: visible;\n    }\n\n    .crud-table .mat-mdc-row ::ng-deep .mat-mdc-cell {\n        transition: 0.3s\n    }\n\n    .crud-table .mat-mdc-row:hover ::ng-deep .mat-mdc-cell {\n        background: #ddd;\n    }\n\n    .crud-table ::ng-deep .mat-mdc-header-cell {\n        color: rgba(0, 0, 0, 0.54);\n    }\n\n    .crud-table ::ng-deep .mat-mdc-chip-list-wrapper {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap !important;\n        align-items: center;\n        margin: -4px;\n    }\n\n    .crud-table ::ng-deep .mat-mdc-menu-panel {\n        min-width: 112px;\n        max-width: 500px !important;\n    }\n\n    .crud-table ::ng-deep.mat-mdc-select-value-text {\n        color: #000\n    }\n\n    .crud-table ::ng-deep .mat-mdc-table .mat-mdc-cell span {\n        display: inline-flex\n    }\n\n    .crud-table ::ng-deep button {\n        border-width: 0px\n    }\n\n    .crud-table ::ng-deep button:hover {\n        transform: scale(1.2);\n    }\n"] }]
        }], ctorParameters: function () { return [{ type: i1.BreakpointObserver }]; }, propDecorators: { name: [{
                type: Input,
                args: ['name']
            }], dataSource: [{
                type: Input,
                args: ['dataSource']
            }], columns: [{
                type: Input,
                args: ['columns']
            }], pageSize: [{
                type: Input,
                args: ['pageSize']
            }], pageSizeOptions: [{
                type: Input,
                args: ['pageSizeOptions']
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }], features: [{
                type: Input,
                args: ['features']
            }] } });

class MsclNgModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: MsclNgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: MsclNgModule, declarations: [CrudTableComponent, GetTitleFromKeyPipe, GetObjectPropertyPipe, ColumnSelectPipe, ColumnValueDirective], imports: [CommonModule, MatChipsModule, MatTableModule, MatPaginatorModule, CdkTableModule, MatIconModule, MatToolbarModule, MatMenuModule, MatCheckboxModule, MatListModule, MatInputModule, FormsModule, MatFormFieldModule], exports: [CrudTableComponent, GetTitleFromKeyPipe, GetObjectPropertyPipe, ColumnSelectPipe, ColumnValueDirective, MatChipsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: MsclNgModule, imports: [CommonModule, MatChipsModule, MatTableModule, MatPaginatorModule, CdkTableModule, MatIconModule, MatToolbarModule, MatMenuModule, MatCheckboxModule, MatListModule, MatInputModule, FormsModule, MatFormFieldModule, MatChipsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: MsclNgModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MatChipsModule, MatTableModule, MatPaginatorModule, CdkTableModule, MatIconModule, MatToolbarModule, MatMenuModule, MatCheckboxModule, MatListModule, MatInputModule, FormsModule, MatFormFieldModule],
                    declarations: [CrudTableComponent, GetTitleFromKeyPipe, GetObjectPropertyPipe, ColumnSelectPipe, ColumnValueDirective],
                    exports: [CrudTableComponent, GetTitleFromKeyPipe, GetObjectPropertyPipe, ColumnSelectPipe, ColumnValueDirective, MatChipsModule]
                }]
        }] });

class PaginationResultMetaInfo {
}
class PaginatedResult {
}

/**
 * Generated bundle index. Do not edit.
 */

export { ColumnSelectPipe, ColumnValueDirective, CrudTableComponent, FilterBase, GetObjectPropertyPipe, GetTitleFromKeyPipe, MongoFilter, MsclNgModule, PaginatedDataSource, PaginatedResult, PaginationResultMetaInfo, getObjectValue, getTitleFromKey, isIp, isIsoDate, objectToQueryString, versionCompare };
